package reading

import AttemptDetail
import ReadingQuestion
import androidx.compose.runtime.*
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun PracticeTaskScreen(
    taskId: Int,
    onExit: () -> Unit
) {
    // --- State ---
    var questions by remember { mutableStateOf<List<ReadingQuestion>>(emptyList()) }
    var isLoading by remember { mutableStateOf(true) }
    var userAnswers by remember { mutableStateOf<Map<String, String>>(emptyMap()) }
    var isFinished by remember { mutableStateOf(false) }
    val startTime = remember { window.performance.now() }

    // Для Tarea 1 (Wizard mode)
    var currentIndex by remember { mutableStateOf(0) }

    // --- Загрузка ---
    LaunchedEffect(taskId) {
        isLoading = true
        questions = DataRepository.fetchQuestionsByTask(taskId)
        isLoading = false
    }

    // --- Логика отображения ---
    Div({
        style {
            width(100.percent)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            padding(20.px)
            property("box-sizing", "border-box")
        }
    }) {
        // 1. Загрузка
        if (isLoading) {
            H3 { Text("⏳ Cargando Tarea $taskId...") }
            return@Div
        }

        // 2. Пусто
        if (questions.isEmpty()) {
            H3 { Text("⚠️ No hay preguntas disponibles.") }
            Button({ onClick { onExit() } }) { Text("Volver") }
            return@Div
        }

        // 3. Результаты
        if (isFinished) {
            // Получаем ID сета из первого вопроса (они все принадлежат одному сету)
            val currentSetId = questions.firstOrNull()?.setId
            val currentSetTitle = "Tarea $taskId (Práctica)"

            // СОХРАНЯЕМ РЕЗУЛЬТАТ ОДИН РАЗ
            LaunchedEffect(Unit) {
                if (currentSetId != null) {

                    val correctCount = questions.count { userAnswers[it.id] == it.correctOption }
                    val total = questions.size
                    // 2. СЧИТАЕМ ВРЕМЯ
                    val endTime = window.performance.now()
                    val durationSeconds = ((endTime - startTime) / 1000).toInt()

                    // 3. ФОРМИРУЕМ ДЕТАЛИЗАЦИЮ (Что ответил, где ошибся)
                    val detailsList = questions.map { q ->
                        val userAnsKey = userAnswers[q.id] ?: "N/A"
                        // Превращаем "A" в текст ответа (опционально, или просто оставляем букву)
                        val userAnsText = when (userAnsKey) {
                            "A" -> "A: ${q.optionA}"
                            "B" -> "B: ${q.optionB}"
                            "C" -> "C: ${q.optionC}"
                            "D" -> "D: ${q.optionD ?: ""}"
                            "E" -> "E: ${q.optionE ?: ""}"
                            else -> "Sin responder"
                        }
                        val correctAnsText = when(q.correctOption) {
                            "A" -> "A: ${q.optionA}"
                            "B" -> "B: ${q.optionB}"
                            "C" -> "C: ${q.optionC}"
                            "D" -> "D: ${q.optionD ?: ""}"
                            "E" -> "E: ${q.optionE ?: ""}"
                            else -> "Opción ${q.correctOption}"
                        }

                        AttemptDetail(
                            question = q.question.take(100), // Обрезаем слишком длинные вопросы
                            userAnswer = userAnsText,
                            correctAnswer = correctAnsText,
                            isCorrect = userAnsKey == q.correctOption
                        )
                    }
                    // Передаем теперь и ID сета
                    DataRepository.saveProgress(taskId, currentSetId, correctCount, questions.size)
// 5. СОХРАНЯЕМ ИСТОРИЮ (TaskAttempt)
                    DataRepository.saveAttempt(
                        taskId = taskId,
                        setTitle = currentSetTitle,
                        score = correctCount,
                        total = total,
                        durationSeconds = durationSeconds,
                        details = detailsList
                    )
                }
            }

            ResultView(questions, userAnswers, onExit)
            return@Div
        }
// --- НОВОЕ: КНОПКА "НАЗАД" (SALIR) ДЛЯ ВСЕХ ЗАДАЧ ---
        // Отображается только если мы НЕ на экране загрузки и НЕ на финише
        Div({
            style {
                width(100.percent)
                maxWidth(1200.px) // Чтобы выравнивалась по ширине контента задач
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.FlexStart) // Прижать влево
                marginBottom(15.px)
            }
        }) {
            Button({
                style {
                    backgroundColor(Color.white)
                    border(1.px, LineStyle.Solid, Color("#bdc3c7"))
                    borderRadius(20.px)
                    padding(8.px, 20.px)
                    cursor("pointer")
                    color(Color("#7f8c8d"))
                    fontWeight("bold")
                    fontSize(1.cssRem)
                    property("box-shadow", "0 2px 5px rgba(0,0,0,0.05)")
                    property("transition", "background-color 0.2s")
                }
                // При наведении можно менять цвет (опционально через hover в css, но здесь инлайн)
                onClick { onExit() }
            }) {
                Text("⬅ Salir")
            }
        }
        // 4. ВЫБОР РЕЖИМА ИНТЕРФЕЙСА
        when (taskId) {
            1 -> Task1Wizard(
                questions = questions,
                currentIndex = currentIndex,
                userAnswers = userAnswers,
                onAnswer = { qId, ans -> userAnswers = userAnswers + (qId to ans) },
                onNext = {
                    if (currentIndex < questions.size - 1) currentIndex++
                    else isFinished = true
                }
            )

            2 -> Task2Layout(
                questions = questions,
                userAnswers = userAnswers,
                onAnswer = { qId, ans -> userAnswers = userAnswers + (qId to ans) },
                onFinish = { isFinished = true }
            )
            // ДОБАВЛЯЕМ TAREA 3
            3 -> Task3Layout(
                questions = questions,
                userAnswers = userAnswers,
                onAnswer = { qId, ans -> userAnswers = userAnswers + (qId to ans) },
                onFinish = { isFinished = true }
            )

            4 -> Task4Layout(
                questions = questions,
                userAnswers = userAnswers,
                onAnswer = { qId, ans -> userAnswers = userAnswers + (qId to ans) },
                onFinish = { isFinished = true }
            )

            5 -> Task5Layout(
                questions = questions,
                userAnswers = userAnswers,
                onAnswer = { qId, ans -> userAnswers = userAnswers + (qId to ans) },
                onFinish = { isFinished = true }
            )
            // Можно использовать reading.Task3Layout и для Tarea 4/5 пока что
            else -> Div { Text("Tarea en desarrollo") }
        }
    }
}

// ==========================================
//  НОВЫЙ ЛЕЙАУТ: TAREA 2 (SPLIT SCREEN)
// ==========================================
@Composable
fun Task2Layout(
    questions: List<ReadingQuestion>,
    userAnswers: Map<String, String>,
    onAnswer: (String, String) -> Unit,
    onFinish: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            property("gap", "30px")
            width(100.percent)
            maxWidth(1200.px)
            // На мобильных переносим колонки друг под друга
            property("flex-wrap", "wrap")
            alignItems(AlignItems.FlexStart) // Прижать к верху
        }
    }) {
        // --- ЛЕВАЯ КОЛОНКА: ТЕКСТ ---
        Div({
            style {
                flex(1) // Занимает 50% места
                minWidth(300.px)
                backgroundColor(Color.white)
                padding(30.px)
                borderRadius(12.px)
                property("box-shadow", "0 4px 15px rgba(0,0,0,0.05)")
                // Делаем текст "липким" при скролле (удобно на десктопе)
                property("position", "sticky")
                property("top", "20px")
                property("height", "fit-content")
            }
        }) {
            H3({ style { marginBottom(20.px); color(Color("#2c3e50")) } }) {
                Text("Lea el texto y responda:")
            }

            // Собираем текст из всех вопросов в один длинный рассказ
            questions.forEach { q ->
                P({
                    style {
                        lineHeight("1.6em")
                        fontSize(1.1.cssRem)
                        marginBottom(15.px)
                        color(Color("#34495e"))
                        textAlign("justify")
                    }
                }) {
                    Text(q.textContent)
                }
            }
        }

        // --- ПРАВАЯ КОЛОНКА: СПИСОК ВОПРОСОВ ---
        Div({
            style {
                flex(1) // Занимает 50% места
                minWidth(300.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                property("gap", "20px")
            }
        }) {
            questions.forEachIndexed { index, question ->
                Div({
                    style {
                        backgroundColor(Color.white)
                        padding(20.px)
                        borderRadius(12.px)
                        property("box-shadow", "0 2px 10px rgba(0,0,0,0.05)")
                    }
                }) {
                    // Номер вопроса
                    Div({
                        style {
                            fontSize(0.9.cssRem)
                            color(Color("#7f8c8d"))
                            marginBottom(10.px)
                            fontWeight("bold")
                        }
                    }) { Text("Pregunta ${index + 1}") }

                    // Сам вопрос
                    H4({ style { marginBottom(15.px); color(Color("#2c3e50")) } }) {
                        Text(question.question)
                    }

                    // Варианты (Компактные)
                    CompactOption("A", question.optionA, userAnswers[question.id] == "A") { onAnswer(question.id, "A") }
                    CompactOption("B", question.optionB, userAnswers[question.id] == "B") { onAnswer(question.id, "B") }
                    CompactOption("C", question.optionC, userAnswers[question.id] == "C") { onAnswer(question.id, "C") }
                }
            }

            // Кнопка завершения (внизу списка вопросов)
            Button({
                style {
                    padding(15.px)
                    backgroundColor(Color("#2ecc71"))
                    color(Color.white)
                    border(0.px)
                    borderRadius(8.px)
                    fontSize(1.2.cssRem)
                    cursor("pointer")
                    width(100.percent)
                    marginTop(20.px)
                }
                onClick { onFinish() }
            }) {
                // Показываем, сколько отвечено
                val answeredCount = userAnswers.keys.count { id -> questions.any { it.id == id } }
                Text(if (answeredCount == questions.size) "Finalizar Test" else "Finalizar ($answeredCount/${questions.size})")
            }
        }
    }
}

// --- ВСПОМОГАТЕЛЬНЫЕ КОМПОНЕНТЫ ---

@Composable
fun Task1Wizard(
    questions: List<ReadingQuestion>,
    currentIndex: Int,
    userAnswers: Map<String, String>,
    onAnswer: (String, String) -> Unit,
    onNext: () -> Unit
) {
    val currentQuestion = questions[currentIndex]

    // Прогресс
    Div({ style { marginBottom(20.px); color(Color("#7f8c8d")) } }) {
        Text("Pregunta ${currentIndex + 1} / ${questions.size}")
    }

    // Карточка (старый стиль)
    Div({
        style {
            backgroundColor(Color.white); borderRadius(12.px); padding(30.px); width(100.percent); maxWidth(800.px)
            property("box-shadow", "0 4px 15px rgba(0,0,0,0.1)")
        }
    }) {
        // Текст
        Div({
            style {
                backgroundColor(Color("#f9f9f9"))
                property("border-left", "4px solid #c0392b") // Красная линия
                padding(15.px); marginBottom(20.px); fontStyle("italic"); color(Color("#2c3e50")); property(
                "line-height",
                "1.5em"
            )
            }
        }) { Text(currentQuestion.textContent) }

        // Вопрос
        H3({ style { marginTop(20.px); marginBottom(20.px); color(Color("#2c3e50")) } }) { Text(currentQuestion.question) }

        // Варианты
        val selected = userAnswers[currentQuestion.id]
        OptionButton("A", currentQuestion.optionA, selected == "A") { onAnswer(currentQuestion.id, "A") }
        OptionButton("B", currentQuestion.optionB, selected == "B") { onAnswer(currentQuestion.id, "B") }
        OptionButton("C", currentQuestion.optionC, selected == "C") { onAnswer(currentQuestion.id, "C") }

        if (selected != null) {
            Button({
                style {
                    marginTop(30.px); width(100.percent); padding(15.px); backgroundColor(Color("#2ecc71"))
                    color(Color.white); border(0.px); borderRadius(6.px); fontSize(1.2.cssRem); cursor("pointer")
                }
                onClick { onNext() }
            }) { Text(if (currentIndex == questions.size - 1) "Finalizar" else "Siguiente →") }
        }
    }
}

@Composable
fun OptionButton(letter: String, text: String, isSelected: Boolean, onClick: () -> Unit) {
    Div({
        onClick { onClick() }
        style {
            display(DisplayStyle.Flex); alignItems(AlignItems.Center); padding(15.px); marginBottom(10.px); borderRadius(
            8.px
        )
            border(1.px, LineStyle.Solid, if (isSelected) Color("#3498db") else Color("#ecf0f1"))
            backgroundColor(if (isSelected) Color("#ebf5fb") else Color.white); cursor("pointer")
        }
    }) {
        Span({ style { fontWeight("bold"); marginRight(15.px); color(if (isSelected) Color("#3498db") else Color("#7f8c8d")) } }) {
            Text(
                "$letter."
            )
        }
        Text(text)
    }
}

@Composable
fun CompactOption(letter: String, text: String, isSelected: Boolean, onClick: () -> Unit) {
    // Более компактный вариант кнопки для Tarea 2
    Div({
        onClick { onClick() }
        style {
            display(DisplayStyle.Flex); alignItems(AlignItems.Center); padding(10.px); marginBottom(8.px); borderRadius(
            6.px
        )
            border(1.px, LineStyle.Solid, if (isSelected) Color("#2980b9") else Color("#ecf0f1"))
            backgroundColor(if (isSelected) Color("#eaf2f8") else Color.white); cursor("pointer")
            fontSize(0.95.cssRem)
        }
    }) {
        Div({
            style {
                minWidth(24.px); height(24.px); borderRadius(50.percent)
                backgroundColor(if (isSelected) Color("#2980b9") else Color("#bdc3c7"))
                color(Color.white); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(
                AlignItems.Center
            )
                marginRight(10.px); fontSize(0.8.cssRem)
            }
        }) { Text(letter) }
        Text(text)
    }
}

@Composable
fun ResultView(questions: List<ReadingQuestion>, userAnswers: Map<String, String>, onExit: () -> Unit) {
    val correctCount = questions.count { userAnswers[it.id] == it.correctOption }
    Div({
        style {
            textAlign("center"); backgroundColor(Color.white); padding(40.px); borderRadius(16.px); property(
            "box-shadow",
            "0 4px 20px rgba(0,0,0,0.1)"
        )
        }
    }) {
        H2 { Text("Resultados") }
        Div({ style { fontSize(4.cssRem); marginTop(20.px); marginBottom(20.px) } }) { Text(if (correctCount >= 3) "🎉" else "📚") }
        H3 { Text("Has acertado $correctCount de ${questions.size}") }
        Button({
            style {
                marginTop(30.px); padding(
                12.px,
                24.px
            ); backgroundColor(Color("#3498db")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer")
            }
            onClick { onExit() }
        }) { Text("Volver al menú") }
    }
}

@Composable
fun Task3Layout(
    questions: List<ReadingQuestion>,
    userAnswers: Map<String, String>,
    onAnswer: (String, String) -> Unit,
    onFinish: () -> Unit
) {
    // Берем текст из первого вопроса (он одинаковый у всех)
    val commonText = questions.firstOrNull()?.textContent ?: ""

    Div({
        style {
            display(DisplayStyle.Flex)
            property("gap", "30px")
            width(100.percent)
            maxWidth(1200.px)
            property("flex-wrap", "wrap")
            alignItems(AlignItems.FlexStart)
        }
    }) {
        // --- ЛЕВАЯ КОЛОНКА: 3 ТЕКСТА ---
        Div({
            style {
                flex(1)
                minWidth(300.px)
                backgroundColor(Color.white)
                padding(30.px)
                borderRadius(12.px)
                property("box-shadow", "0 4px 15px rgba(0,0,0,0.05)")
                property("position", "sticky")
                property("top", "20px")
                property("height", "fit-content")
                // Поддержка переноса строк из базы данных (\n)
                property("white-space", "pre-line")
            }
        }) {
            H3({ style { marginBottom(20.px); color(Color("#2c3e50")) } }) {
                Text("Lea los textos y responda:")
            }

            // Просто выводим форматированный текст
            P({
                style {
                    lineHeight("1.6em")
                    fontSize(1.05.cssRem)
                    color(Color("#34495e"))
                }
            }) {
                Text(commonText)
            }
        }

        // --- ПРАВАЯ КОЛОНКА: УТВЕРЖДЕНИЯ (ВОПРОСЫ) ---
        Div({
            style {
                flex(1)
                minWidth(300.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                property("gap", "15px")
            }
        }) {
            questions.forEachIndexed { index, question ->
                Div({
                    style {
                        backgroundColor(Color.white)
                        padding(20.px)
                        borderRadius(12.px)
                        property("box-shadow", "0 2px 8px rgba(0,0,0,0.05)")
                    }
                }) {
                    // Номер
                    Span({ style { fontWeight("bold"); color(Color("#7f8c8d")); fontSize(0.85.cssRem) } }) {
                        Text("Enunciado ${index + 1}:")
                    }

                    // Утверждение
                    P({ style { margin(0.px); marginTop(10.px); marginBottom(15.px); fontWeight("500") } }) {
                        Text(question.question)
                    }

                    // 3 Кнопки в ряд (A, B, C)
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            property("gap", "10px")
                        }
                    }) {
                        // Функция для рисования кнопок
                        listOf("A", "B", "C").forEach { option ->
                            val isSelected = userAnswers[question.id] == option
                            Button({
                                onClick { onAnswer(question.id, option) }
                                style {
                                    flex(1) // Растянуть на всю ширину
                                    padding(8.px)
                                    border(
                                        1.px,
                                        LineStyle.Solid,
                                        if (isSelected) Color("#3498db") else Color("#bdc3c7")
                                    )
                                    backgroundColor(if (isSelected) Color("#3498db") else Color.white)
                                    color(if (isSelected) Color.white else Color("#7f8c8d"))
                                    borderRadius(6.px)
                                    cursor("pointer")
                                    fontWeight("bold")
                                }
                            }) { Text("Texto $option") }
                        }
                    }
                }
            }

            // Кнопка завершения
            Button({
                style {
                    marginTop(20.px)
                    padding(15.px)
                    backgroundColor(Color("#8e44ad")) // Фиолетовый цвет для разнообразия
                    color(Color.white)
                    border(0.px)
                    borderRadius(8.px)
                    fontSize(1.2.cssRem)
                    cursor("pointer")
                    width(100.percent)
                }
                onClick { onFinish() }
            }) {
                val answeredCount = userAnswers.size
                Text("Finalizar Tarea 3 ($answeredCount/${questions.size})")
            }
        }
    }
}

@Composable
fun Task4Layout(
    questions: List<ReadingQuestion>,
    userAnswers: Map<String, String>,
    onAnswer: (String, String) -> Unit,
    onFinish: () -> Unit
) {
    val commonText = questions.firstOrNull()?.textContent ?: ""
    // Берем варианты из первого вопроса (они одинаковые для всех в этом сете)
    val qSample = questions.firstOrNull()
    val optionsList = if (qSample != null) {
        listOfNotNull(
            "A" to qSample.optionA,
            "B" to qSample.optionB,
            "C" to qSample.optionC,
            qSample.optionD?.let { "D" to it },
            qSample.optionE?.let { "E" to it }
        )
    } else emptyList()

    Div({
        style {
            display(DisplayStyle.Flex)
            property("gap", "30px")
            width(100.percent)
            maxWidth(1200.px)
            property("flex-wrap", "wrap")
            alignItems(AlignItems.FlexStart)
        }
    }) {
        // --- ЛЕВАЯ КОЛОНКА: ТЕКСТ ---
        Div({
            style {
                flex(1)
                minWidth(300.px)
                backgroundColor(Color.white)
                padding(40.px)
                borderRadius(12.px)
                property("box-shadow", "0 4px 15px rgba(0,0,0,0.05)")
                property("position", "sticky")
                property("top", "20px")
                property("height", "fit-content")
            }
        }) {
            H3({ style { marginBottom(20.px); color(Color("#2c3e50")) } }) {
                Text("Lea el texto y elija la frase correcta:")
            }

            P({
                style {
                    lineHeight("2.2em")
                    fontSize(1.1.cssRem)
                    color(Color("#34495e"))
                    property("white-space", "pre-line")
                    textAlign("justify")
                }
            }) {
                Text(commonText)
            }
        }

        // --- ПРАВАЯ КОЛОНКА: ВАРИАНТЫ + ОТВЕТЫ ---
        Div({
            style {
                flex(1)
                minWidth(300.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                property("gap", "20px")
            }
        }) {
            // 1. БАНК ФРАЗ (Справочник)
            Div({
                style {
                    backgroundColor(Color("#ecf0f1")) // Серый фон для отличия
                    padding(20.px)
                    borderRadius(12.px)
                    border(1.px, LineStyle.Solid, Color("#bdc3c7"))
                }
            }) {
                H4({ style { margin(0.px); marginBottom(15.px); color(Color("#7f8c8d")) } }) {
                    Text("Opciones disponibles (una sobra):")
                }

                // Выводим список фраз A, B, C, D, E
                optionsList.forEach { (letter, text) ->
                    Div({ style { marginBottom(10.px); fontSize(0.95.cssRem) } }) {
                        Span({ style { fontWeight("bold"); color(Color("#2980b9")); marginRight(8.px) } }) { Text("$letter.") }
                        Text(text)
                    }
                }
            }

            // 2. БЛОКИ ОТВЕТОВ (Espacio 1, 2, 3, 4)
            questions.forEachIndexed { index, question ->
                Div({
                    style {
                        backgroundColor(Color.white)
                        padding(15.px)
                        borderRadius(12.px)
                        property("box-shadow", "0 2px 8px rgba(0,0,0,0.05)")
                        property("border-left", "4px solid #8e44ad") // Фиолетовая полоска
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                    }
                }) {
                    // Заголовок
                    Div({ style { marginBottom(10.px); fontWeight("bold"); color(Color("#2c3e50")) } }) {
                        Text("ESPACIO (${index + 1})")
                    }

                    // Ряд кнопок A B C D E
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            property("gap", "8px")
                        }
                    }) {
                        optionsList.forEach { (letter, _) ->
                            val isSelected = userAnswers[question.id] == letter
                            Button({
                                onClick { onAnswer(question.id, letter) }
                                style {
                                    padding(8.px, 15.px)
                                    backgroundColor(if (isSelected) Color("#8e44ad") else Color("#f4f6f7"))
                                    color(if (isSelected) Color.white else Color("#2c3e50"))
                                    border(
                                        1.px,
                                        LineStyle.Solid,
                                        if (isSelected) Color("#8e44ad") else Color("#d5dbdb")
                                    )
                                    borderRadius(6.px)
                                    cursor("pointer")
                                    fontWeight("bold")
                                }
                            }) {
                                Text(letter)
                            }
                        }
                    }

                    // Показываем выбранный текст (подсказка для пользователя)
                    val selectedLetter = userAnswers[question.id]
                    if (selectedLetter != null) {
                        val selectedText = optionsList.find { it.first == selectedLetter }?.second ?: ""
                        Div({ style { marginTop(10.px); fontSize(0.9.cssRem); color(Color("#8e44ad")); fontStyle("italic") } }) {
                            Text("Seleccionado: $selectedText")
                        }
                    }
                }
            }

            // Кнопка завершения
            Button({
                style {
                    marginTop(20.px); padding(15.px); backgroundColor(Color("#2c3e50")); color(Color.white)
                    border(0.px); borderRadius(8.px); fontSize(1.2.cssRem); cursor("pointer"); width(100.percent)
                }
                onClick { onFinish() }
            }) {
                val answeredCount = userAnswers.size
                Text("Finalizar Tarea 4 ($answeredCount/${questions.size})")
            }
        }
    }
}

@Composable
fun Task5Layout(
    questions: List<ReadingQuestion>,
    userAnswers: Map<String, String>,
    onAnswer: (String, String) -> Unit,
    onFinish: () -> Unit
) {
    val commonText = questions.firstOrNull()?.textContent ?: ""

    Div({
        style {
            display(DisplayStyle.Flex)
            property("gap", "30px")
            width(100.percent)
            maxWidth(1200.px)
            property("flex-wrap", "wrap")
            alignItems(AlignItems.FlexStart)
        }
    }) {
        // --- ЛЕВАЯ КОЛОНКА: ТЕКСТ (Длинный) ---
        Div({
            style {
                flex(1)
                minWidth(300.px)
                backgroundColor(Color.white)
                padding(40.px)
                borderRadius(12.px)
                property("box-shadow", "0 4px 15px rgba(0,0,0,0.05)")
                // Текст должен "прилипать" при прокрутке длинного списка вопросов
                property("position", "sticky")
                property("top", "20px")
                property("height", "fit-content")
                // Ограничим высоту, если текст слишком длинный, и добавим скролл внутри, если нужно
                property("max-height", "90vh")
                property("overflow-y", "auto")
            }
        }) {
            H3({ style { marginBottom(20.px); color(Color("#2c3e50")) } }) {
                Text("Lea el texto y elija la opción correcta:")
            }

            P({
                style {
                    lineHeight("2em")
                    fontSize(1.1.cssRem)
                    color(Color("#34495e"))
                    property("white-space", "pre-line")
                    textAlign("justify")
                }
            }) {
                Text(commonText)
            }
        }

        // --- ПРАВАЯ КОЛОНКА: 12 ВОПРОСОВ ---
        Div({
            style {
                flex(1)
                minWidth(300.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                property("gap", "15px")
            }
        }) {
            questions.forEachIndexed { index, question ->
                // Карточка вопроса (более компактная, так как их 12)
                Div({
                    style {
                        backgroundColor(Color.white)
                        padding(15.px)
                        borderRadius(8.px)
                        property("box-shadow", "0 2px 5px rgba(0,0,0,0.05)")
                        property("border-left", "4px solid #16a085") // Бирюзовая полоска
                    }
                }) {
                    // Заголовок (Номер пропуска)
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            marginBottom(10.px)
                            fontSize(0.9.cssRem)
                            color(Color("#7f8c8d"))
                            fontWeight("bold")
                        }
                    }) {
                        Text("ESPACIO (${index + 1})")
                    }

                    // Варианты A, B, C (в ряд или столбик, если слова длинные)
                    Div({
                        style {
                            display(DisplayStyle.Grid)
                            // Автоматическая сетка: если места мало, перенесет на новую строку
                            property("grid-template-columns", "repeat(auto-fit, minmax(100px, 1fr))")
                            property("gap", "8px")
                        }
                    }) {
                        // Кнопка A
                        OptionButtonCompact(
                            text = question.optionA,
                            isSelected = userAnswers[question.id] == "A",
                            onClick = { onAnswer(question.id, "A") }
                        )
                        // Кнопка B
                        OptionButtonCompact(
                            text = question.optionB,
                            isSelected = userAnswers[question.id] == "B",
                            onClick = { onAnswer(question.id, "B") }
                        )
                        // Кнопка C
                        OptionButtonCompact(
                            text = question.optionC,
                            isSelected = userAnswers[question.id] == "C",
                            onClick = { onAnswer(question.id, "C") }
                        )
                    }
                }
            }

            // Кнопка завершения
            Button({
                style {
                    marginTop(20.px); padding(15.px); backgroundColor(Color("#16a085")); color(Color.white)
                    border(0.px); borderRadius(8.px); fontSize(1.2.cssRem); cursor("pointer"); width(100.percent)
                    marginBottom(40.px) // Отступ снизу страницы
                }
                onClick { onFinish() }
            }) {
                val answeredCount = userAnswers.size
                Text("Finalizar Tarea 5 ($answeredCount/${questions.size})")
            }
        }
    }
}

// Компактная кнопка для Tarea 5 (похожа на OptionButtonSimple, но чуть меньше паддинги)
@Composable
fun OptionButtonCompact(text: String, isSelected: Boolean, onClick: () -> Unit) {
    Button({
        onClick { onClick() }
        style {
            padding(8.px)
            backgroundColor(if (isSelected) Color("#16a085") else Color("#f4f6f7")) // Бирюзовый активный
            color(if (isSelected) Color.white else Color("#2c3e50"))
            border(1.px, LineStyle.Solid, if (isSelected) Color("#16a085") else Color("#d5dbdb"))
            borderRadius(6.px)
            cursor("pointer")
            fontSize(0.95.cssRem)
            width(100.percent)
            property("transition", "all 0.1s")
            // Обрезаем длинный текст, если нужно (или оставляем перенос)
            property("word-wrap", "break-word")
        }
    }) {
        Text(text)
    }
}